import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "32",
  height: "32",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M20.55 6.251a2.668 2.668 0 0 0-3.599-.82l-.518.31a1.572 1.572 0 0 0-.925-.303H8.183a1.57 1.57 0 0 0-.732.184l-.403-.242a2.67 2.67 0 0 0-3.6.821 2.716 2.716 0 0 0 .461 3.521l3.84 3.392c.05.177.1.354.155.528.62 2.024 1.358 3.424 2.23 4.22a3.817 3.817 0 0 0-1.767 3.221V22h7.575v-.917c0-1.413-.769-2.649-1.908-3.307.24-.239.466-.523.678-.857.515-.808.966-1.93 1.34-3.335.033-.127.066-.255.097-.383l3.942-3.429a2.716 2.716 0 0 0 .462-3.52h-.002zM5.11 8.345a.869.869 0 0 1-.147-1.127.854.854 0 0 1 1.152-.262l.51.305c.084.689.22 1.683.426 2.799L5.11 8.345zm3.351-1.073h6.78c-.48 5.55-1.81 9.55-3.187 9.55-1.378 0-2.891-4-3.593-9.55zm1.949 12.895a1.968 1.968 0 0 1 1.743-1.064c.756 0 1.414.432 1.743 1.064H10.41zM18.893 8.39l-2.177 1.893c.163-1.072.267-2.049.331-2.777l.836-.5a.855.855 0 0 1 1.152.262.867.867 0 0 1-.142 1.122z" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M8.461 7.272h6.78c-.48 5.55-1.81 9.55-3.187 9.55-1.378 0-2.891-4-3.593-9.55zM10.41 20.167a1.968 1.968 0 0 1 1.743-1.064c.756 0 1.414.432 1.743 1.064H10.41z",
  class: "background",
  fill: "#006240",
  "fill-opacity": "0"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}